module.exports = __webpack_public_path__ + "static/smileportrait-f2a6973c2033875b46a90f8dfdc503d2.jpg";